export const enum RetailTableColumnId {
  Name = 'name',
  Email = 'email',
  Phone = 'phone',
  DefaultPayment = 'defaultPayment',
  UnpaidBalance = 'unpaidBalance',
  UnpaidInvoices = 'unpaidInvoices',
  BillingAddress = 'billingAddress',
  ShippingAddress = 'shippingAddress',
  LastActivity = 'lastActivity',
  Notes = 'notes',
  Actions = 'actions',
}

export type CardBrand = 'visa' | 'mastercard' | 'amex' | 'discover';

export interface RetailCustomerPayment {
  brand: CardBrand;
  lastFour: string;
}

export interface RetailUnpaidSale {
  id: number;
  idOnMkp: string | null;
  label: string;
  amount: number;
  currency: string;
}

export interface RetailCustomer {
  id: number;
  name: string;
  email: string;
  phone: string;
  defaultPayment: RetailCustomerPayment | null;
  unpaidBalance: number;
  unpaidSales: RetailUnpaidSale[];
  billingAddress: string;
  shippingAddress: string;
  lastActivity: string; // ISO date string
  notes: string;
}
